import { render, staticRenderFns } from "./badgeList.vue?vue&type=template&id=cc01d8a8&scoped=true&lang=pug&"
import script from "./badgeList.vue?vue&type=script&lang=js&"
export * from "./badgeList.vue?vue&type=script&lang=js&"
import style0 from "./badgeList.vue?vue&type=style&index=0&id=cc01d8a8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc01d8a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc01d8a8')) {
      api.createRecord('cc01d8a8', component.options)
    } else {
      api.reload('cc01d8a8', component.options)
    }
    module.hot.accept("./badgeList.vue?vue&type=template&id=cc01d8a8&scoped=true&lang=pug&", function () {
      api.rerender('cc01d8a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/myPage/userId/badgeList.vue"
export default component.exports